export const environment = {
  production: true,
  cb: new Date().getTime(),
  hybrisBasePath: 'https://api.qa5.amway.co.th',
  hybrisBaseSite: 'amwaythailand',
  occProductSearchClientId: 'G7pFh6TwSt3r90LBE8Zl53KN9hD3',
  appCountryCode: 'TH',
  appCountryName: 'Thailand',
  affiliateCode: '200',
  magicBasePath: 'https://api-ts2.amwayglobal.com',
  hybrisIdpPath: 'https://idp.qa5.amway.co.th',
  hybrisSfBasepath: 'https://www.qa5.amway.co.th',
  idpClientId: 'h32j1kl78dsd921m23d76sjk', //idp.creator.client.id
  masheryRegisterCaptchaSitekey: '6Lcd4Z4UAAAAAA4kjeFkTQUREdnpsUR--psmSL17', //mashery.register.captcha.sitekey.amwaythailand
  masheryRegisterClientId: 'gwcmw995fqsa593wsuj8kd4r', //mashery.register.clientid.amwaythailand
  registrationCaptchaClientId: 'pA1KPHepXOeuAG3KduKG4Lkm', //registration.trustedclient.clientid.amwaythailand
  registrationCaptchaClientSecret: 'QSvONvw7qhjdCRAgGr0kxARH', //registration.trustedclient.clientsecret.amwaythailand
  sharebarapiurl: 'https://th.dev.ashare.me/',
  splunkMeta: {
    url: 'https://http-inputs-amway.splunkcloud.com/services/collector/event',
    token: '5B9A8687-E0DF-41FC-A8C1-701E9B7CAEB0',
    index: 'hybris-itv-creator'
  },
  splunkSourceEnv: 'MYLIST-TH-QA5',
  authClientSecret: 'xtMMN2osot'
};
